<template>
  <div :class="['agentBox', isDark ? 'darkAgentBox' : '']">
    <div class="title">
      <h2>代理中心</h2>
    </div>
    <div class="tabsBox">
      <div
        v-for="(item, index) in tabsList" 
        :key="index" 
        :class="[item.activeName === activeName ? 'chooseTab' : '']"
        @click="changeTabs(item.activeName)"
      >
        {{ item.title }}{{ item.unread ? `(${item.unread})` : '' }}
      </div>
    </div>
    <div class="tabsContent scrollStyle" ref="wrapper" @scroll="handleScroll">
      <!-- 邀请记录 -->
      <div v-if="activeName === 'inviteRecord'">
        <template v-if="inviteData.length > 0">
          <div v-for="(item, index) in inviteData" :key="`invite${index}`">
            <Msg :news="item"  :isShowTimeIcon="true"></Msg>
          </div>
          <div v-if="query.totalPage > 1" class="load-more" @click="loadMore">{{ query.pageNo == query.totalPage ? '我也是有底线的0_0' : '加载更多' }}</div>
        </template>
        <el-empty v-else description="暂无用户数据"></el-empty>
      </div>
      <!-- 佣金记录 -->
      <div v-if="activeName === 'brokerageRecord'">
        <div class="brokerageBox">
          <div class="priceBox">
            <p>总佣金(元)</p>
            <b>{{ commissionTotal }}</b>
          </div>
          <div class="priceBox">
            <p>待结算佣金(元)</p>
            <b>{{ commissionTotalTodo }}</b>
          </div>
        </div>
        <div :class="['search', isDark ? 'datePickerDark' : '']" :key="datePickerKey">
          <el-date-picker
            prefix-icon="el-icon-search"
            v-model="datePicker"
            type="daterange"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :editable="false"
            :popper-class="datePopper"
            @change="searchPicker"
          >
          </el-date-picker>
          <!-- <el-input placeholder="开始时间-结束时间" v-model="searchDate">
            <div slot="suffix" class="searchIcon">
              <i class="el-icon-search"></i>
            </div> 
          </el-input> -->
        </div>
        <template v-if="commissionData.length">
          <div v-for="(item, index) in commissionData" :key="`brokerage${index}`">
            <Msg :news="item" :isShowTimeIcon="true"></Msg>
          </div>
          <div v-if="query.totalPage > 1" class="load-more" @click="loadMore">{{ query.pageNo == query.totalPage ? '我也是有底线的0_0' : '加载更多' }}</div>
        </template>
        <el-empty v-else description="暂无佣金数据"></el-empty>
      </div>
      <!-- 积分兑换 -->
      <div v-if="activeName === 'integralExchange'">
        <Msg :news="msgOne"></Msg>
        <div v-for="(item, index) in msgList" :key="`integral${index}`">
          <Msg :news="item" :isAction="true" @payGood="payGood" actionText="我要兑换">
          </Msg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Msg from '../+components/Msg';
import {mapState} from 'vuex';
import api from "@/api";

export default {
  name: 'Agent',
  components: {Msg},
  props: {},
  data () {
    return {
      activeName: 'inviteRecord',
      datePicker: '',
      datePickerKey: 0, // 日期输入框key
      tabsList: [
        {
          title: '邀请记录',
          unread: 0,
          activeName: 'inviteRecord',
        },
        {
          title: '佣金记录',
          unread: 0,
          activeName: 'brokerageRecord',
        },
        // {
        //   title: '分享链接',
        //   activeName: 'inviteLink',
        // },
        // {
        //   title: '积分兑换',
        //   activeName: 'integralExchange',
        // },
      ],
      inviteData: [
        // {
        //   avatar: require('@/assets/chatImg/user-2.png'),
        //   textTitle: 'user001',
        //   textContent: '邀请时间:2024-03-14 16:26',
        // },
      ],
      commissionData: [
        // {
        //   avatar: require('@/assets/chatImg/user-2.png'),
        //   textTitle: 'user001',
        //   textContent: '充值时间:2024-03-14 16:26',
        //   payPrice: '60',
        // },
      ],
      msgList: [
        {
          avatarText: {
            text: '天',
            background: '#007bff',
          },
          textTitle: '￥9.9 / 3天',
          textContent: '消耗积分：100',
        },
        {
          avatarText: {
            text: '周',
            background: '#007bff',
          },
          textTitle: '￥19.9 / 周',
          textContent: '消耗积分：300',
        },
        {
          avatarText: {
            text: '月',
            background: '#007bff',
          },
          textTitle: '￥69 / 月',
          textContent: '消耗积分：1000',
        },
      ],
      msgOne: {
        avatarText: {
          text: 'M',
          background: '#ffc107',
        },
        textTitle: '当前积分：1000',
        textContent: '积分可以兑换套餐'
      },
      query:{
				pageNo:1,
				pageSize:10,
				totalPage:1,
			},
      commissionTotal:0, //当前佣金
      commissionTotalTodo:0, //待结算佣金
      datePicker:null, //日期
    }
  },
  computed: {
    ...mapState('comAbout', ['isDark']),
    // 日期选择下拉样式
    datePopper() {
      return this.isDark ? 'datePopper' : '';
    },
  },
  watch: {
    isDark: {
      handler() {
        this.datePickerKey++
      },
      immediate: true,
    },
  },
  created () {},
  mounted () {
    window.addEventListener("tabsContent",this.handleScroll)
		this.getInviteRecord();
    this.getCommissionRecord();
		// this.shareUrl()
  },
  methods: {
    //日期搜索
		async searchPicker(){
			await this.clearQuery()
			this.getCommissionRecord();
		},
    handleScroll() {
			const scrollTop = this.$refs.wrapper.scrollTop;
			const containerHeight = this.$refs.wrapper.clientHeight;
			const contentHeight = this.$refs.wrapper.scrollHeight;
			// console.log("数据3",scrollTop + containerHeight)
			// console.log("数据4",contentHeight)
			//loading防止重复加载，scrollTop > this.lastScrollTop防止向上滑动触发
			if (scrollTop + containerHeight >= (contentHeight - 1) && this.loading == false && scrollTop > this.lastScrollTop) {
				// this.$message("加载更多")
				this.loadMore()
			}
			this.lastScrollTop = scrollTop
		},
    changeTabs(activeName) {
      this.activeName = activeName;
      this.clearQuery();
      if(activeName === 'inviteRecord'){
        this.getInviteRecord()
      } else if (this.activeName === 'brokerageRecord') {
        this.getCommissionRecord();
      }
    },
    //清除页码
		clearQuery(){
			this.query.pageNo = 1
			this.query.totalPage = 1
			this.inviteData = []
			this.commissionData = []
		},
    //佣金记录
		async getCommissionRecord(){
			this.loading = true;
			const params = {}
			//日期处理
			if(this.datePicker != null){
				params.sTime = this.$utils.dateFormat(this.datePicker[0], 'yyyy-MM-dd')
				params.eTime = this.$utils.dateFormat(this.datePicker[1], 'yyyy-MM-dd')
			}
			await api.CommissionRecord(Object.assign(params,this.query)).then((res) => {
				if(res.code == 200){
					const arr = res.data.rows.map(item => {
            return {
              ...item,
              avatar: item.avatarURL,
              textTitle: item.account,
              textContent: `充值时间：${item.createdTime}`,
              payPrice: item.commission,
            }
          })
					if(arr.length > 0){
						this.commissionData = this.commissionData.concat(arr)
					}
					this.commissionTotal = res.data.commissionTotal
					this.commissionTotalTodo = res.data.commissionTotalTodo
          this.tabsList[1].unread = res.data.totalRows
					this.query.totalPage = res.data.totalPage
				}else{
					this.$message.error(res.message)
				}
				this.loading = false
			})
			.catch((err) => {
				this.$message.error(err)
				this.loading = false
			})
		},
    loadMore(){
			// 触底，触发加载更多方法
			const { pageNo,totalPage } = this.query
			if(pageNo < totalPage){
				 this.query.pageNo += 1
				 if(this.activeName === 'inviteRecord'){
				 	this.getInviteRecord()
				 } else if (this.activeName === 'brokerageRecord') {
          this.getCommissionRecord()
         }
				//  if(this.tabActive == 1){
				//  	this.getCommissionRecord()
				//  }
			}
		},
    //邀请记录
		async getInviteRecord(){
			this.loading = true;
			await api.InviteRecord(this.query).then((res) => {
				if(res.code == 200){
					const arr = res.data.rows.map(item => {
            return {
              ...item,
              avatar: item.avatarURL,
              textTitle: item.account,
              textContent: `邀请时间：${item.createdTime}`,
            }
          })
					if(arr.length > 0){
						this.inviteData = this.inviteData.concat(arr)
					}
					this.tabsList[0].unread = res.data.totalRows
					// this.totalRows = res.data.totalRows
					this.query.totalPage = res.data.totalPage
				}else{
					this.$message.error(res.message)
				}
				this.loading = false
			})
			.catch((err) => {
				this.$message.error(err)
				this.loading = false
			})
		},
    // 积分兑换
    payGood(item) {
      console.log(item);
    },
  }
}
</script>

<!-- 佣金记录选择时间移动端样式 -->
<style>
/** 移动端展示 **/
@media screen and (max-width: 500px) {
    .el-picker-panel__sidebar {
      width: 100%;
    }
    .el-picker-panel {
      width: 300px!important;
    }
    .el-picker-panel__content {
      width: 100%;
    }
    .el-picker-panel__body{
      margin-left: 0!important;
      display: flex;
      flex-direction: column;
      min-width: auto!important;
    }
    .el-picker-panel__sidebar {
      position: relative;
    }
    .el-picker-panel__body-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

</style>

<style scoped lang="less">
.agentBox {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    h2 {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .tabsBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, .08);
    padding: 0px 0px 10px 0;
    margin: 16px 0 8px;
    color: #6c757d;
    div {
      cursor: pointer;
    }
    .chooseTab{
      color: #007bff;
    }
  }
  .tabsContent {
    overflow: auto;
    .load-more{
      text-align: center;
      margin-top: 10px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      cursor: pointer;
      margin-bottom: 30px;
    }
    .brokerageBox{
      display: flex;
      font-size: 14px;
      justify-content: space-between;
      margin: 16px 0;
      .priceBox {
        color: #6c757d;
        text-align: center;
      }
    }
    .search {
      margin: 4px 4px 16px;
      height: 55px;
      .popper {
        max-width: 100%;
      }
      .searchIcon {
        height: 55px;
        width: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 20px;
        }
      }
    }
    .inviteTitle {
      margin: 8px 0 5px;
      font-size: 14px;
      font-weight: bold;
      line-height: 21px;
      color: #0c0c0d;
    }
    .inviteHint {
      color: #6c757d;
      font-size: 80%;
    }
    // .linkInput {
    //   margin: 16px 4px;
    // }
    // .copyBtn {
    //   background-color: #2f80ec;
    //   min-width: 150px;
    //   border-radius: 8px;
    //   line-height: 45px;
    //   height: 45px;
    //   padding: 0 20px;
    //   font-size: 13px;
    //   color: #fff;
    //   font-family: Montserrat, sans-serif;
    //   box-shadow: 0 8px 30px rgba(0, 0, 0, .03);
    //   border: 0;
    // }
  }
}
.darkAgentBox {
  .tabsBox {
    color: #fff;
  }
  .tabsContent {
    .brokerageBox{
      .priceBox {
        color: #ddd;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.search {
  ::v-deep .el-input__inner {
  // ::v-deep .el-date-editor--datetimerange.el-input__inner{
    background-color: #ebeff4;
    border: 0;
    border-radius: 8px;
    height: 55px;
    line-height: 55px;
    font-size: 13px;
    padding: 0 20px;
    width: 100%;
  }
  ::v-deep .el-range-input {
    background: #ebeff4;
  }
  ::v-deep .el-date-editor .el-input__icon {
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-date-editor .el-range-separator {
    line-height: 55px;
    color: #606266;
  }
}
.datePickerDark {
  ::v-deep .el-date-editor--datetimerange.el-input__inner{
    background-color: #293145;
  }
  ::v-deep .el-range-input {
    background: #293145;
    color: #ddd;
  }
  ::v-deep .el-input__inner {
  // ::v-deep .el-date-editor--datetimerange.el-input__inner{
    background-color: #293145;
  }
}
</style>